import React from "react";

// --- Data Constants and Arrays ---

// Personal Information
const PERSONAL_INFO = {
  name: "Garaga Krishna Santosh",
  title: "React Native Developer - Android/IOS",
  email: "krishna.santho08@gmail.com",
  phone: "(91) 8309677743",
};

// Summary
const SUMMARY = "React Native Developer with six years of experience developing mobile applications. Passionate about creating inclusive and impactful solutions in a software development role to contribute my skills in software engineering, innovation, and problem-solving to build products that empower individuals worldwide. Highly motivated and eager to learn new things in my free time.";

// Main Projects Array
const PROJECTS_DATA = [
  {
    title: 'OTTPlay',
    desc: 'Access premium content from 12 OTTs for only 1199/yr. Watch 20,000+ movies & shows in 10+ languages across varied genres. Includes Native Modules for extended functionality.',
    tag: 'React-Native / Native Modules',
  },
  {
    title: 'Smart Power Launcher',
    desc: 'A Simple, Smart, and Secure Launcher with 1K+ Downloads and 4.3 Ratings.',
    tag: 'Flutter',
    type: 'personal', // Added type for filtering
  },
  {
    title: 'Ezpro',
    desc: 'Application for organizations to link with and arrange client meetings with 1T+ users. Users receive meeting details via email.',
    tag: 'React-Native / Spring Boot / Java',
  },
  {
    title: 'EZPro-SSO',
    desc: 'Similar to Ezpro but with a Single-Sign-On feature, allowing users to sign in once and access multiple organization applications without re-signing in.',
    tag: 'React-Native / Keycloak / Angular / Java',
  },
  {
    title: 'JConnect',
    desc: 'Web-based project to monitor and organize 300+ patients and 40+ organizations for clinical audit trials.',
    tag: 'React JS / Spring Boot / Java',
  },
  {
    title: 'My Active Health App',
    desc: 'An application by CVS health company providing science-based coaching, workout challenges, and guidance via audio, video, and articles for health care problems.',
    tag: 'React-Native',
  },
  {
    title: 'SIP (Shared Investigator Platform)',
    desc: 'A standardized feasibility process powered by Cognizant® Shared Investigator Platform that drives efficiencies and improves the user experience for both site and sponsor teams.',
    tag: 'React-Native',
  },
  {
    title: 'react-native-typing-animation-effect',
    desc: 'A plugin to create typing effects with ease, increasing flexibility to use anywhere in the component. (Not a company project)',
    tag: 'React-Native / Plugin',
    link: 'https://www.npmjs.com/package/react-native-typing-animation-effect',
    type: 'personal', // Added type for filtering
  },
  {
    title: 'react-native-tv-cast',
    desc: 'A plugin to easily cast content from an Android phone to any Smart TV connected to the internet. (Not a company project)',
    tag: 'React-Native / Plugin',
    link: 'https://www.npmjs.com/package/react-native-tv-cast',
    type: 'personal', // Added type for filtering
  },
];

// --- Categorization ---
const PERSONAL_PROJECTS = PROJECTS_DATA.filter(p => p.type === 'personal');
const BUSINESS_PROJECTS = PROJECTS_DATA.filter(p => p.type !== 'personal');

// --- App Component ---

export default function App() {
  const [dark, setDark] = React.useState(true);
  const toggleTheme = () => setDark((s) => !s);

  React.useEffect(() => {
    // disable horizontal scroll at document level
    try {
      document.documentElement.style.overflowX = 'hidden';
      document.body.style.margin = '0';
      document.body.style.transition = 'background-color 300ms, color 300ms, font-size 200ms';
    } catch (e) {}
  }, []);

  React.useEffect(() => {
    // sync body colors/size
    try {
      document.body.style.background = dark ? '#000' : '#fff';
      document.body.style.color = dark ? '#fff' : '#000';
      document.body.style.fontSize = dark ? '20px' : '16px';
    } catch (e) {}
  }, [dark]);

  // Project Card Component to keep the main return clean
  const ProjectCard = ({ p, i, isBusiness }) => (
    <article key={p.title} className="project-card" style={{ animationDelay: `${i * 120}ms` }}>
      <div className="project-head">
        <h3>{p.title}</h3>
        {/* Conditional Tag Rendering */}
        <span className="tag">{isBusiness ? 'Business' : p.tag}</span>
      </div>
      <p className="project-desc">{p.desc}</p>
      
      {/* Conditional Actions Rendering (Only for Personal Projects) */}
      {!isBusiness && (
        <div className="project-actions">
          <button className="mini">View</button>
          {p.link && (
            <a href={p.link} target="_blank" rel="noopener noreferrer" className="mini primary">
              NPM
            </a>
          )}
        </div>
      )}
    </article>
  );

  return (
    <div className={`app-root ${dark ? 'theme-dark' : 'theme-light'}`}>
      {/* Visual layers — fixed so they don't create layout overflow */}
      <div className="visuals" aria-hidden>
        <div className="gradient" />

        {/* multiple bubble elements spread across the screen for more natural look */}
        {/* <div className="blob b1" /> */}
        <div className="blob b2" />
        {/* <div className="blob b3" /> */}
        <div className="blob b4" />
        <div className="blob b5" />
      </div>

      <main className="container">
        <div className="card">
          <header className="header">
            <h1 className="title">Hola 👋 — I'm {PERSONAL_INFO.name}</h1>
            <p className="intro">{SUMMARY}</p>
            <div className="actions">
              <a className="btn ghost" href="#business-projects">Business Projects</a>
              <a className="btn ghost" href="#personal-projects">Personal Projects</a>
              <a className="btn" href={`mailto:${PERSONAL_INFO.email}`}>Contact</a>
            </div>
          </header>

          {/* BUSINESS PROJECTS SECTION */}
          <section id="business-projects" className="projects-grid-container">
            <h2>🏢 Business Projects</h2>
            <div className="projects-grid">
              {BUSINESS_PROJECTS.map((p, i) => (
                <ProjectCard key={p.title} p={p} i={i} isBusiness={true} />
              ))}
            </div>
          </section>

          {/* PERSONAL PROJECTS SECTION */}
          <section id="personal-projects" className="projects-grid-container" style={{ marginTop: '48px' }}>
            <h2>👨‍💻 Personal & Hobby Projects</h2>
            <div className="projects-grid">
              {PERSONAL_PROJECTS.map((p, i) => (
                <ProjectCard key={p.title} p={p} i={i} isBusiness={false} />
              ))}
            </div>
          </section>


          <footer id="contact" className="footer">
            Want to collaborate? <a href={`mailto:${PERSONAL_INFO.email}`}>Let’s talk →</a>
          </footer>
        </div>
      </main>

      {/* Theme toggle bottom-right */}
      <button onClick={toggleTheme} className="theme-toggle" aria-label="Toggle theme">
        {dark ? 'Switch to Light' : 'Switch to Dark'}
      </button>

      <style>{`
        /* reset */
        *,*::before,*::after{box-sizing:border-box}
        html,body,#root{height:100%;}
        body{font-family:Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial;}

        .app-root{min-height:100vh;position:relative;overflow-x:hidden}
        .container{position:relative;z-index:3;display:flex;align-items:center;justify-content:center;min-height:100vh;padding:48px 20px}
        .card{width:100%;max-width:1100px;border-radius:16px;padding:28px;border:1px solid rgba(0,0,0,0.06);backdrop-filter:blur(6px)}

        /* text sizes */
        .title{font-size:28px;margin:0 0 8px 0}
        .intro{margin:0 0 14px 0;opacity:0.95}
        .actions{display:flex;gap:12px;margin-top:12px}
        .btn{display:inline-block;padding:8px 12px;border-radius:10px;text-decoration:none}
        .btn.ghost{background:transparent;border:1px solid rgba(0,0,0,0.06)}

        /* Project Grid - The key to responsiveness */
        .projects-grid-container h2 { margin: 24px 0 12px 0; font-size: 22px; }
        .projects-grid{
            display: grid;
            grid-template-columns: repeat(1, 1fr); /* Mobile: 1 card per row */
            gap: 12px;
            margin-top: 18px;
            /* Ensure vertical stretch across the row */
            align-items: stretch;
        }
        @media(min-width: 600px){
             .projects-grid{
                 grid-template-columns: repeat(2, 1fr); /* Tablet: 2 cards per row */
            }
        }
        @media(min-width: 1024px){
             .projects-grid{
                 grid-template-columns: repeat(3, 1fr); /* Large Screen: Max 3 cards per row */
            }
        }
        
        .project-card{
            padding:14px;
            border-radius:12px;
            animation:fadeUp 600ms ease both;
            border: 1px solid transparent; /* default */
            transition: all 300ms;
            
            /* Flexbox to manage vertical content inside the card */
            display: flex;
            flex-direction: column;
            height: 100%; /* Card fills the entire height of the grid cell */
            
            /* Enforce a minimum height for short content cards */
            min-height: 180px; 
        }
        .project-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }
          

        .project-head{
            display:flex;
            justify-content:space-between;
            align-items:flex-start;
            margin-bottom:8px;
        }
        .project-card h3{margin:0;font-size:16px}
        .tag{font-size:12px;padding:4px 8px;border-radius:8px; white-space: nowrap; opacity: 0.7;}
        
        .project-desc{
            margin:0 0 10px 0;
            font-size:14px;
            /* Ensures description takes up all available vertical space */
            flex-grow: 1; 
        }

        .project-actions{display:flex;gap:8px; margin-top: auto; /* Pushes actions to the bottom */}
        .mini{padding:6px 8px;border-radius:8px; border: 1px solid transparent; cursor: pointer; transition: background 200ms}
        .mini.primary{background: #4f46e5; color: #fff; border-color: #4f46e5}
        .mini.primary:hover{opacity: 0.9;}

        @keyframes fadeUp{from{transform:translateY(10px);opacity:0}to{transform:none;opacity:1}}

        /* Visual layers fixed and non-interactive */
        .visuals{position:fixed;inset:0;z-index:1;pointer-events:none;overflow:hidden}

        /* Base gradient used in both themes; will be tuned per theme */
        .gradient{position:absolute;inset:0;background: black;background-size:600% 600%;animation:gradientShift 18s ease infinite;transition:opacity 350ms, filter 350ms}
        @keyframes gradientShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}

        /* bubble common styles */
        .blob{position:absolute;border-radius:50%;opacity:0.85;filter:blur(80px) saturate(1.2);transition:opacity 300ms, filter 300ms, transform 300ms}

        /* individual bubble sizes + positions + animations (using updated sizes) */
    .b1{width:520px;height:520px;left:-8%;top:-6%;background:radial-gradient(circle at 30% 30%, rgba(99,102,241,0.95), rgba(59,130,246,0.6) 40%, transparent 60%);animation:float1 20s infinite ease-in-out}
    .b2{width:420px;height:420px;right:-6%;top:8%;background:radial-gradient(circle at 70% 30%, rgba(236,72,153,0.95), rgba(245,158,11,0.6) 40%, transparent 60%);animation:float2 24s infinite ease-in-out}
    .b3{width:640px;height:640px;left:10%;bottom:-12%;background:radial-gradient(circle at 60% 60%, rgba(34,197,94,0.95), rgba(14,165,233,0.6) 40%, transparent 60%);animation:float3 28s infinite ease-in-out}
    .b4{width:260px;height:260px;left:50%;top:6%;transform:translateX(-50%);background:radial-gradient(circle at 40% 40%, rgba(99,102,241,0.85), rgba(236,72,153,0.4) 50%, transparent 60%);animation:float4 18s infinite ease-in-out}
    .b5{width:180px;height:180px;right:20%;bottom:20%;background:radial-gradient(circle at 30% 30%, rgba(245,158,11,0.85), rgba(34,197,94,0.4) 50%, transparent 60%);animation:float5 22s infinite ease-in-out}

        /* UPDATED KEYFRAMES FOR WIDER MOVEMENT ACROSS THE SCREEN */
    @keyframes float1{
            0%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
            50%{transform:translateY(-15vh) translateX(12vw) scale(1.03);}
            100%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
        }
    @keyframes float2{
            0%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
            50%{transform:translateY(18vh) translateX(-15vw) scale(0.98);}
            100%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
        }
    @keyframes float3{
            0%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
            50%{transform:translateY(-22vh) translateX(18vw) scale(1.04);}
            100%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
        }
    @keyframes float4{
            0%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
            50%{transform:translateY(10vh) translateX(-8vw) scale(1.02);}
            100%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
        }
    @keyframes float5{
            0%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
            50%{transform:translateY(-10vh) translateX(6vw) scale(1.01);}
            100%{transform:translateY(0vh) translateX(0vw) scale(1.0);}
        }

        /* Theme: Light */
    .theme-light{color:#000}
    .theme-light .card{
            background: transparent;
            border-color:rgba(0,0,0,0.06);
            box-shadow:0 6px 30px rgba(15,23,42,0.06)
        }
        /* FIX: Greatly reduced opacity and increased blur for visible transparency */
        .theme-light .project-card{
            background: rgba(255,255,255,0.1); /* <-- Much lower opacity */
            border-color: rgba(0,0,0,0.06);
            backdrop-filter: blur(8px); /* <-- Increased blur for visibility */
        }
        .theme-light .project-card:hover {
            /* Provide solid feedback on hover */
            background: rgba(255,255,255,0.8);
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.05);
        }
        .theme-light .tag{background: rgba(0,0,0,0.05); color: #000; }
        .theme-light .mini{background: rgba(0,0,0,0.05); color: #000; border-color: rgba(0,0,0,0.06);}
        .theme-light .mini:hover{background: rgba(0,0,0,0.1); }
    .theme-light .gradient{opacity:0.18;mix-blend-mode:normal;filter:blur(6px) saturate(1)}
    .theme-light .blob{mix-blend-mode:normal;opacity:0.65;filter:blur(60px) saturate(1)}

    /* Theme: Dark */
    .theme-dark{color:#fff}
    .theme-dark .card{background:linear-gradient(180deg, rgba(255,255,255,0.02), rgba(255,255,255,0.01));border-color:rgba(255,255,255,0.06)}
        .theme-dark .project-card{background: rgba(255,255,255,0.03); border-color: rgba(255,255,255,0.06); }
        .theme-dark .tag{background: rgba(255,255,255,0.1); color: #fff; }
        .theme-dark .mini{background: rgba(255,255,255,0.08); color: #fff; border-color: rgba(255,255,255,0.1);}
        .theme-dark .mini:hover{background: rgba(255,255,255,0.15); }
    .theme-dark .gradient{opacity:0.9;mix-blend-mode:screen;filter:blur(18px) saturate(1.1)}
    .theme-dark .blob{mix-blend-mode:screen;opacity:0.9;filter:blur(80px) saturate(1.2)}

    /* Theme toggle */
    .theme-toggle{position:fixed;right:20px;bottom:20px;z-index:4;padding:10px 14px;border-radius:999px;border:none;cursor:pointer;background:rgba(255,255,255,0.06);backdrop-filter:blur(6px);color:inherit}

    /* responsive tweaks */
    @media(max-width:520px){
     .card{padding:18px}
     .title{font-size:20px}
     .visuals .b1,.visuals .b2,.visuals .b3{filter:blur(110px)}
    }
     .footer {
            margin-top: 48px; /* Added space above the footer */
            font-size: 18px;
            text-align: center;
            opacity: 0.8;
        }
   `}</style>
    </div>
  );
}